import axios from 'axios';

 

const apiClient = axios.create({
    // baseURL: 'http://localhost:8000',
    // baseURL: 'http://104.248.53.221',
    baseURL: 'https://adminapi.bpdteam.com',

    withCredentials: true,

});

 

export default apiClient;